import React, {useEffect, useState} from 'react';
import {Box, Paper} from "@material-ui/core";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {useUserContext} from "../../context/UserContext";
import AgentUnMappedRecordsListView from "./AgentUnMappedRecordsListView";
import {Link} from "@mui/material";
import LeadsTaggedAgentListView from "./LeadsTaggedAgentListView";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

function AdminReferDashboard({lead,onReturnBack}) {
    const [tabValue, setTabValue] = React.useState(0);
    const {user,dispatch} = useUserContext();
    const [actionClicked, setActionClicked] = useState(false);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleActionClicked = (status) =>{
        console.log("Status", status);
        setActionClicked(status);
    }

    return (
        <Box m={1}>
            <br/>
            {!actionClicked && 
            <>
            <Box component="span" justifyContent="flex-start" marginLeft="16px" marginTop="8px"
                 alignItems="flex-end" display="flex">
                <Link onClick={() => onReturnBack()}>Back to Quote Search</Link>
            </Box>
            <br/>
            <Box justifyContent="flex-start" marginLeft="16px" marginTop="8px"
                 alignItems="flex-end" display="flex">
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h5" component="h2">
                        Property Address
                        </Typography>
                        <b>
                            <span>{lead?.addressLine1}</span>&nbsp;
                            <span>{lead?.addressLine2}</span><br/>
                            <span>{lead?.city}</span>, <span>{lead?.state}</span>, <span>{lead?.zip1}</span>
                        </b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h5" component="h2">
                            Consumer Details
                        </Typography>
                        <b>
                            <span>Name: {lead?.firstName} {lead?.lastName}</span>&nbsp;<br/>
                            <span>Email: {lead?.email}</span><br/>
                            <span>Phone: {lead?.cellPhoneNumber}</span>
                        </b>
                    </Grid>
                </Grid>
            </Box>
            </>
        }
            <Paper>
                <Box>
                {!actionClicked && 
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="agent options"
                    >
                        <Tab label="Matched Agents"/>
                    </Tabs>
                }
                </Box>                         
            </Paper>
              {
                  tabValue === 0 && <LeadsTaggedAgentListView lead={lead} onActionClick={handleActionClicked}/>
                }    
        </Box>
    )

}

export default AdminReferDashboard;
